<template>
  <div
    class="asd20-slider-input"
    :style="`--progress-color: ${progressColor}; --percentage: ${percentage};`"
  >
    <label
      v-if="label"
      for="sliderInput"
      class="asd20-slider-input__label"
      v-html="label"
    />
    <input
      id="sliderInput"
      type="range"
      :value="value"
      @input="$emit('input', Number($event.target.value))"
      :min="min"
      :max="max"
      :step="step"
    />
  </div>
</template>

<script>
export default {
  name: 'Asd20SliderInput',

  props: {
    label: { type: String, default: '' },
    value: { type: Number, default: 50 },
    progressColor: { type: String, default: '' },
    min: { type: Number, default: 0 },
    max: { type: Number, default: 100 },
    step: { type: Number, default: 1 },
  },

  computed: {
    percentage() {
      return Math.round((this.value / this.max) * 100) + '%'
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_mixins.scss';
@import '../../../design/_variables.scss';

$track-color: var(--color__tertiary);
$track-height: space(0.5);
$thumb-size: space(1);
$thumb-hover-size: space(1.125);
$thumb-active-size: space(1.25);
$thumb-color: var(--color__accent);
$thumb-active-color: var(--color__accent);
$thumb-hover-color: var(--color__accent-t20);
$thumb-outline-color: var(--color__accent-t50);
$track-margin: $thumb-size / 2 - $track-height / 2;

.asd20-slider-input {
  --percentage: 50%;
  --progress-color: var(--color__accent);
  position: relative;
  display: flex;
  flex-direction: column;
  &::before {
    content: '';
    position: absolute;
    height: $track-height;
    width: 100%;
    bottom: $track-margin;
    left: 0;
    z-index: 0;
    background: var(--color__accent-t80);
    border-radius: $track-height;
  }
  &::after {
    content: '';
    position: absolute;
    height: $track-height;
    width: var(--percentage);
    bottom: $track-margin;
    left: 0;
    z-index: 0;
    background: var(--progress-color);
    border-radius: $track-height 0 0 $track-height;
  }
  label {
    display: block;
  }
  input[type='range'] {
    position: relative;
    z-index: 1;
    -webkit-appearance: none;
    width: 100%;
    background: transparent;
    margin: $track-margin 0;
    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      border-radius: 50%;
      background: white;
      box-shadow: 0 0 0 2px $thumb-color inset;
      cursor: pointer;
      height: $thumb-size;
      width: $thumb-size;
      margin-top: calc(#{$thumb-size * -0.5} + #{$track-height / 2});
      transition: all 0.1s ease-out;
    }
    &::-webkit-slider-runnable-track {
      width: 100%;
      height: $track-height;
      cursor: pointer;
      background: transparent;
      box-shadow: 0 0 0 1px $thumb-color inset;
      border-radius: $track-height;
    }
    &:focus {
      // outline: none;
      &::-webkit-slider-thumb {
        box-shadow: 0 0 0 2px $thumb-hover-color inset,
          0 0 0 0.5rem $thumb-outline-color;
      }
    }
    &:hover {
      // outline: none;
      &::-webkit-slider-thumb {
        height: $thumb-hover-size;
        width: $thumb-hover-size;
        margin-top: calc(#{$thumb-hover-size * -0.5} + #{$track-height / 2});
        box-shadow: 0 0 0 2px $thumb-hover-color inset,
          0 0 0 0.5rem $thumb-outline-color;
      }
    }
    &:active {
      // outline: none;
      &::-webkit-slider-thumb {
        height: $thumb-active-size;
        width: $thumb-active-size;
        margin-top: calc(#{$thumb-active-size * -0.5} + #{$track-height / 2});
        box-shadow: 0 0 0 2px $thumb-active-color inset,
          0 0 0 0.5rem $thumb-outline-color;
      }
    }
  }
}
</style>
